import { TAPU_MAHALLE } from "../constants/requestUrls";
import {  postRequest } from "../request";

const tapuMahalleList = (ParselId,Ada,Parsel) => {
    let filterModel= {};
    filterModel.ParselId=ParselId;
    filterModel.Ada=Ada;
    filterModel.Parsel=Parsel;
    let data = JSON.stringify(filterModel);
    
    return postRequest({url:TAPU_MAHALLE,data});
}

export default tapuMahalleList;